import * as React from "react";
import { forwardRef } from "react";
const SvgPauseFilled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.5998 5.3999H7.7998V24.5999H12.5998V5.3999Z", fill: "#5B95A3" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1994 5.3999H17.3994V24.5999H22.1994V5.3999Z", fill: "#5B95A3" }));
const ForwardRef = forwardRef(SvgPauseFilled);
export { ForwardRef as ReactComponent };
